import(/* webpackMode: "eager" */ "/vercel/path1/src/app/about/page.tsx");
